<script lang="ts">
	import { Button, Container, Icon, Modal, Text, toast } from '@Shelly/shelly-design-system/index';
	import { requestDeleteThermostat } from 'src/components/Lists/list-helpers';
	import { resetDrawer, resetDrawerClose } from 'src/helpers/drawer_helpers';
	import { devices_status } from 'src/stores/device-runtime/status';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { scenes } from 'src/stores/lists/scenes';
	import { format } from 'svelte-i18n';
	import { createAsyncAction } from 'src/helpers/async_action_guard';

	export let showDeleteThermostatModal = false;
	export let items;
	export let thermostat_id: string;
	export let thermostat_name: string;

	const { loading: deleteLoading, run: runDelete } = createAsyncAction();

	const onCloseDeleteModal = () => {
		showDeleteThermostatModal = false;
	};

	const onDeleteThermostat = () =>
		runDelete(async () => {
			const res = await requestDeleteThermostat(thermostat_id);

			if (res.isok) {
				scenes.remove(thermostat_id);
				devices_status.remove(thermostat_id);
				if ($showNewLayout) {
					resetDrawerClose();
				} else {
					resetDrawer();
				}
				// When we are on edit mode items are not reactive
				if (items) {
					items = items?.filter((thermostat) => thermostat._id !== thermostat_id);
				} else {
					items = [];
				}
			} else {
				toast.open({
					type: 'danger',
					title: $format('alert_failed_deleted_thermostat', {
						default: 'Failed to delete the thermostat',
					}),
				});
			}
			onCloseDeleteModal();
		});
</script>

<Modal
	on:close={onCloseDeleteModal}
	showModal={showDeleteThermostatModal}
	title={$format('prompt_title_delete_thermostat', {
		default: 'Delete thermostat?',
	})}
>
	<Container slot="content" padding="0">
		<div class="d-flex flex-direction-column align-items-center">
			<Icon size="xxl" icon="fa-light fa-trash" class="text-danger mb-xs" />
			<Text class="text-bold text-center mb-s" styleType="controls-large">
				{thermostat_name}
			</Text>
			<Text class="width-full">
				{$format('on_delete_item_msg', {
					values: {
						device_name: thermostat_name,
						type: $format('process_thermostat', {
							default: 'thermostat',
						}).toLowerCase(),
					},
					default: `Deleting ${$format('process_thermostat', {
						default: 'thermostat',
					}).toLowerCase()} ‘${thermostat_name}’ will permanently remove it from your account.`,
				})}
			</Text>
		</div>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onCloseDeleteModal}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			loading={$deleteLoading}
			on:click={onDeleteThermostat}
		>
			{$format('button_delete_thermostat', { default: 'Delete thermostat' })}
		</Button>
	</div>
</Modal>
